import { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import SplitNumber from "../_Components/SplitNumber";
import { useLocation } from "react-router-dom";
import SwalMessage from "../_Components/SwalMessage";
import Swal from "sweetalert2";
import _ from "lodash";
import ApiTransaction from "../../../core/api/api.transaction";
import { EditModal } from "./EditModal";
import { ViewModal } from "./ViewModal";
import { UploadFiles } from "../FilesService/UploadFiles";
import { Button } from "react-bootstrap";

function DataGrid({ data, setShowModalTransaction, setShowModalEditTransaction, setSelectedTransaction }) {
  let location = useLocation();

  const handleDelete = (item) => (event) => {
    deleteMessage(item);
  };
  async function deleteMessage(item) {
    Swal.fire({
      title: "عملیات حذف تراکنش",
      text: "ایا قصد حذف این تراکنش را دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        deleteApi(item);
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    });
  }
  async function deleteApi(item) {
    const response = await ApiTransaction.deleteTransaction(item.id);
    if (response.succeeded == true) document.getElementById("submitButton").click();

    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }

  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 20,
      },
      {
        accessor: "basketId",
        Header: "شماره سفارش",
        minWidth: "100px",
      },
      {
        accessor: "basketItemPersonId",
        Header: "شماره بلیط",
        minWidth: "100px",
      },
      {
        accessor: "userFullName",
        Header: "نام مشتری",
        minWidth: "130px",
      },
      {
        accessor: "titleS",
        Header: "عنوان",
        minWidth: "100px",
      },
      // {
      //     Header: "مبدا",
      //     minWidth: 100,
      //     align: "center",
      //     Cell: ({ row }) => (
      //         (row.original.sourceAgency) ?
      //             <div className="text-center success">
      //                 {row.original.sourceAgency?.name}
      //                 -
      //                 {row.original.sourceAccount?.cardNumber}
      //             </div>
      //             :
      //             <div className="text-center success">
      //                 {!_.isEmpty(row.original.sourceTitle) ? row.original.sourceTitle : ""}
      //             </div>
      //     )
      // },
      // {
      //     Header: "مقصد",
      //     minWidth: 100,
      //     align: "center",
      //     Cell: ({ row }) => (
      //         (row.original.destinationAgency) ?
      //             <div className="text-center success">
      //                 {row.original.destinationAgency?.name}
      //                 -
      //                 {row.original.destinationAccount?.cardNumber}
      //             </div>
      //             :
      //             <div className="text-center success">
      //                 {!_.isEmpty(row.original.destinationTitle) ? row.original.destinationTitle : ""}
      //             </div>
      //     )
      // },
      {
        Header: "مبلغ",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          // row.original.destinationAgencyId === idAgency ?
          //     <div className="text-center success">
          //         <ArrowDownwardIcon />
          //         <SplitNumber number={row.original.amount} />
          //     </div>
          //     :
          //     <div className="text-center danger">
          //         <ArrowUpwardIcon />
          //         <SplitNumber number={row.original.amount} />
          //     </div>
          <div className="text-center success">
            <SplitNumber number={row.original.amount} />
          </div>
        ),
      },
      {
        Header: "اعتبار",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          // row.original.destinationAgencyId === idAgency ?
          //     <div className="text-center success">
          //         <ArrowDownwardIcon />
          //         <SplitNumber number={row.original.creditAmount} />
          //     </div>
          //     :
          //     <div className="text-center danger">
          //         <ArrowUpwardIcon />
          //         <SplitNumber number={row.original.creditAmount} />
          //     </div>
          <div className="text-center success">
            <SplitNumber number={row.original.creditAmount} />
          </div>
        ),
      },
      {
        Header: "تاریخ  تراکنش",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {_.toString(row.original.completionDate)} - {_.toString(row.original.completionTime)}
          </div>
        ),
      },
      {
        Header: "وضعیت",
        minWidth: 50,
        align: "center",
        Cell: ({ row }) =>
          row.original.isDeleted ? <div className="text-center">حذف شده</div> : <div className="text-center">فعال</div>,
      },
      {
        accessor: "description",
        Header: "توضیحات",
        minWidth: "100px",
      },
      //{
      //  accessor: "strActorType",
      //  Header: "عامل تراکنش",
      //  minWidth: 90,
      //  maxWidth: 90,
      //  align: "center",
      //},
      //{
      //  accessor: "strSupplierSettlementType",
      //  Header: "نحوه تسویه",
      //  minWidth: 90,
      //  maxWidth: 90,
      //  align: "center",
      //},
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 200,
        align: "right",
        Cell: ({ row }) => (
          <div className="">
            {/* مشاهده  */}
            <Button
              className="btn btn-light-info btn-sm mr-2 btn-icon"
              title="مشاهده اطلاعات"
              onClick={() => {
                setSelectedTransaction(row.original.id);
                setShowModalTransaction(true);
              }}
            >
              <i className="far fa-eye text-small"></i>
            </Button>
            {/* ویرایش  */}
            {(row.original.title == 5 ||
              row.original.title == 6 ||
              row.original.title == 8 ||
              row.original.title == 10) &&
              !row.original.isDeleted && (
                <Button
                  title="ویرایش "
                  className="btn btn-light-primary btn-sm mr-2 btn-icon"
                  onClick={() => {
                    setSelectedTransaction(row.original.id);
                    setShowModalEditTransaction(true);
                  }}
                >
                  <i className="far fa-edit text-small"></i>
                </Button>
              )}
            {/* حذف  */}
            {(row.original.title == 5 ||
              row.original.title == 6 ||
              row.original.title == 8 ||
              row.original.title == 10) &&
              !row.original.isDeleted && (
                <button
                  onClick={handleDelete(row.original)}
                  title=" حذف"
                  className="btn btn-light-danger btn-sm btn-icon"
                  type="button"
                >
                  <i className="far fa-trash-alt text-small"></i>
                </button>
              )}
            {/* {آپلود فایل} */}
            <UploadFiles transationsId={row.original.id}></UploadFiles>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      {location.pathname === "/editTransaction/1" && !_.isEmpty(location.state) && _.isNumber(location.state?.id) ? (
        <ViewModal />
      ) : (
        <></>
      )}
      {location.pathname === "/editTransaction/0" && !_.isEmpty(location.state) && _.isNumber(location.state?.id) ? (
        <EditModal />
      ) : (
        <></>
      )}
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
